import React, { useState } from 'react'

export const UrlSelector = (({onComplete}) => {
  const [value, setValue] = useState(undefined);
  const probablyOk = value && value.length && !value.match(/\s+/) && !!value.match(/.+\..{2,}/);
  const submit = () => probablyOk && onComplete && onComplete(
    value.indexOf('http') === 0 ? value : 'http://' + value
  )
  return <div style={{padding: '30px 0'}}>
    <form onSubmit={submit}>
      <div className="input-group">
        <input className="form-control"
               autoFocus
               type="text"
               value={value}
               onChange={(e) => {
                 let url = e.target.value.trim()
                 setValue(url)
               }}/>
        <span className="input-group-btn">
        <button
          className={`btn btn-secondary ${probablyOk ? '' : 'disabled'} rounded-0-left`}
          onClick={submit}
        >Add</button>
      </span>
      </div>
      <span className="text-muted">A link to a site, article, image or a video, e.g. https://en.wikipedia.org/wiki/Social_media</span>
    </form>
  </div>
})
